import axios from "axios";
import React, { useState, useEffect } from "react";
import { Heading, TextInput } from "blueprints2";
import Loading from "./components/Loading";
import UserHistoryList from "./components/UserHistoryList";
import { FormattedMessage, injectIntl } from "react-intl";
import Header from "./components/Header";

function Settings({ workspace, locale, intl }) {
  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [developer, setDeveloper] = useState([]);
  const [history, setHistory] = useState([]);
  const devUrl = "/" + workspace + "/developer";

  useEffect(() => {
    axios
      .get(devUrl, { withCredentials: true })
      .then((res) => {
        const developer = res.data;
        const devMeta = JSON.parse(developer.meta);

        setDeveloper(developer);
        if (devMeta.migrated !== "false" && devMeta.migrated !== "") {
          setHistory((history) => [
            ...history,
            {
              name: intl.formatMessage({
                id: "settings.user.migration_date",
              }),
              date: devMeta.migrated,
            },
          ]);
        }
        setIsLoaded(true);
      })
      .catch((err) => {
        console.error(err);
        setError(true);
        setIsLoaded(true);
      });
  }, [devUrl]);

  if (error) {
    return (
      <div>
        <Header workspace={workspace} locale={locale} />
        <div className="react_page__component">
          <FormattedMessage id="settings.error" />
        </div>
      </div>
    );
  } else if (!isLoaded) {
    return (
      <div>
        <Header workspace={workspace} locale={locale} />
        <div className="react_page__component">
          <div className="settings mx-auto">
            <Heading level={2}>
              <FormattedMessage id="settings.title" />
            </Heading>
            <div className="border-b border-gray-400"></div>
            <Loading />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <Header workspace={workspace} locale={locale} />
        <div className="react_page__component">
          <div className="settings mx-auto">
            <Heading level={2}>
              <FormattedMessage id="settings.title" />
            </Heading>
            <div className="border-b border-gray-400"></div>
            <TextInput
              className="disabled-settings py-6"
              isDisabled
              name="custom_id"
              label={<FormattedMessage id="settings.user.email" />}
              placeholder={developer.custom_id}
            />
            <br />
            <br />

            {history.length > 0 && <UserHistoryList userHistory={history} />}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(Settings);
